import * as React from 'react'
import { css, styled } from 'next-yak'
import * as PropTypes from 'prop-types'

import * as colors from '../constants/colors.ts'

export const StyledAvatar = styled.img.attrs((props) => ({
  size: props.size ? `${props.size}px` : '1em',
}))`
  object-fit: cover;
  border-radius: 50%;
  ${(props) =>
    props.src &&
    css`
      background-image: ${() => `url(${props.src})`};
    `}
  background-position: center;
  background-size: cover;
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  ${(props) =>
    props.border &&
    css`
      border: 2px solid ${colors.PRIMARY_GREY_000};
    `};
  ${(props) =>
    props.shadow &&
    css`
      box-shadow: #0006 0 2px 4px;
    `};
`

/** Beautiful picture chosen by user */
const Avatar = (props) => <StyledAvatar {...props} />

Avatar.propTypes = {
  /** if not defined, size will be equal to 1em */
  size: PropTypes.number,
  /** if true, add a border */
  border: PropTypes.bool,
  /** if true, add a shadow */
  shadow: PropTypes.bool,
  /** url of the avatar */
  src: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}
Avatar.displayName = 'legacy.Avatar'

export default Avatar
